var map = {
	"./brown_3-6.png": "./src/assets/brown_3-6.png",
	"./green_3-6.png": "./src/assets/green_3-6.png",
	"./grey_3-6.png": "./src/assets/grey_3-6.png",
	"./red_3-6.png": "./src/assets/red_3-6.png",
	"./yellow_3-6.png": "./src/assets/yellow_3-6.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets sync recursive ^\\.\\/.*_3\\-6\\.png$";